import { IonHeader, IonToolbar, IonTitle, IonButtons, useIonViewWillEnter } from '@ionic/react';
import React from 'react';
import './HeaderSos.css';
import MenuButton from './MenuButton';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
// import noti from '../asset/img/noti.png';

interface ContainerProps {
    pageName: string;
}

const HeaderSos: React.FC<ContainerProps> = ({ pageName }) => {

    // Este bloque se ejecutará cada vez que una página con este header se vaya a mostrar
    useIonViewWillEnter(() => {
        const setStatusBarColor = async () => {
            // Solo se ejecuta en la app móvil
            if (Capacitor.isNativePlatform()) {
                // Establece el color rojo para la barra de estado
                await StatusBar.setBackgroundColor({ color: '#e5100b' });
            }
        };
        setStatusBarColor();
    });

    return (
        <IonHeader mode="ios" className="header-red ion-no-border">
            <IonToolbar className="header-page header-sos-background-color">
                <IonButtons slot="start">
                    <MenuButton />
                </IonButtons>

                <IonTitle>
                    {pageName}
                </IonTitle>

                {/* <a onClick={() => window.location.href = url }><img src={noti} className="notifications col-6"/></a> */}
            </IonToolbar>
        </IonHeader>
    );
}

export default HeaderSos;